import { Box, styled } from "@mui/material";
import { colors } from "../../styles/theme";

export const Container = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  position: 'relative',
  alignItems: 'center',
}));

export const Item = styled(Box)(({ theme }) => ({
  display: 'inline-block',
  lineHeight: 1,
  // cursor: 'pointer',
}));

export const Indicator = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  opacity: 0,
  transform: 'translateX(-50%)',
  background: colors.text.v4,
  borderRadius: '5px',
  zIndex: 3,
}));